export default "__VITE_ASSET__V61PX8DQ__"